import React from 'react';
import {TeamSelectionPlayer} from './types';

interface PlayerTooltipProps {
  hoverInfo: { player?: TeamSelectionPlayer; x: number; y: number };
  savedPerformance: Record<string, number>;
}

const PlayerTooltip: React.FC<PlayerTooltipProps> = ({ hoverInfo, savedPerformance }) => {
  if (!hoverInfo.player) return null;
  return (
    <div
      className="fixed z-50 bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded shadow-lg px-3 py-2 text-xs"
      style={{ left: hoverInfo.x + 12, top: hoverInfo.y + 12 }}
      role="tooltip"
    >
      <div className="font-semibold text-gray-900 dark:text-gray-100">{hoverInfo.player.name}</div>
      <div className="text-gray-600 dark:text-gray-300">{hoverInfo.player.position}{hoverInfo.player.team ? ` • ${hoverInfo.player.team}` : ''}</div>
      <div className="mt-1 text-gray-700 dark:text-gray-200">
        Saved avg:
        <span className="font-semibold ml-1">
          {savedPerformance[hoverInfo.player.id] ?? '—'}
        </span>
        <span className="mx-1">→</span>
        Current:
        <span className="font-semibold ml-1">
          {hoverInfo.player.latestPerformanceRating || 'No data'}
        </span>
      </div>
    </div>
  );
};

export default PlayerTooltip;
